export default __webpack_public_path__ + "static/media/flutterwave_logo_color.654d5ed6.svg";